(function () {
  var ROOT = '.yumwoof-landing-page';
  var UNLOCK_URL =
    '/discount/BFCM,BFCM-FREEBIES-PPP,BFCM-FREEBIES-YUMCLUB?redirect=/collections/all';

  var FAQ_ICON_PLUS =
    'M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4';
  var FAQ_ICON_MINUS = 'M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5';

  function initFaq() {
    document.querySelectorAll(ROOT + ' [data-replo-collapsible]').forEach(function (item) {
      var trigger = item.querySelector('[role="button"][aria-controls]');
      if (!trigger) return;

      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : item.querySelector('[hidden]');
      if (!panel) return;

      var iconPath = trigger.querySelector('svg path');

      function setOpen(open) {
        item.setAttribute('data-state', open ? 'open' : 'closed');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        if (iconPath) iconPath.setAttribute('d', open ? FAQ_ICON_MINUS : FAQ_ICON_PLUS);
      }

      function toggle() {
        setOpen(item.getAttribute('data-state') !== 'open');
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        toggle();
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  function initUnlockOffer() {
    document.querySelectorAll(ROOT + ' button').forEach(function (btn) {
      if (!/Unlock Offer/i.test(btn.textContent)) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = UNLOCK_URL;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFaq();
      initUnlockOffer();
    });
  } else {
    initFaq();
    initUnlockOffer();
  }
})();
